/* eslint-disable @typescript-eslint/no-magic-numbers */
import { ROUTES } from 'AppRoutes';
import Menu from 'components/Menu';
import { ReactElement } from 'react';
import { FaRegUser } from 'react-icons/fa';
import { GrUserSettings } from 'react-icons/gr';
import { HiMiniArrowLeftStartOnRectangle } from 'react-icons/hi2';
import { IoChevronBack } from 'react-icons/io5';
import { useLocation, useNavigate } from 'react-router-dom';
import useStore from '../store';

interface HeaderProperties {
  headerTitle: string;
  children: ReactElement;
  showBack: boolean;
}

function Header({ headerTitle, children, showBack }: HeaderProperties): ReactElement {
  const navigate = useNavigate();
  const location = useLocation();
  const exitRoutes = new Set([ROUTES.INSTRUCTIONS]);
  const { setSelectedSubject, logoutStudent } = useStore();
  const onBack = exitRoutes.has(location.pathname)
    ? () => {
        setSelectedSubject(undefined);
        navigate(-1);
      }
    : () => navigate(-1);

  const menuOptions = [
    {
      onClick: () => {
        navigate(ROUTES.STUDENT_PROFILE);
      },
      label: 'Student Profile',
      icon: <FaRegUser style={{ color: '#999999' }} />,
    },
    {
      onClick: () => {
        navigate(ROUTES.ADMIN_PROFILE, { replace: true });
      },
      label: 'Admin',
      icon: <GrUserSettings style={{ color: '#999999' }} />,
    },
    {
      onClick: () => {
        logoutStudent({ source: 'ui' });
        navigate(ROUTES.STUDENT_LOGIN);
      },
      label: 'Logout',
      icon: <HiMiniArrowLeftStartOnRectangle style={{ color: '#999999' }} />,
    },
  ];
  return (
    <div className="min-w-screen flex h-screen flex-col overflow-hidden pt-[90px]">
      <header className="absolute top-0 z-30 w-full bg-secondary-blue-3 p-4 text-neutral-white shadow-lg">
        <div className="container mx-auto flex items-center justify-center">
          <h1 className="font-lilita text-[2.5em] font-bold leading-[1.5]">{headerTitle}</h1>
          {showBack && (
            <button
              type="button"
              aria-label="Go Back"
              className=" absolute left-7 z-20 flex h-[40px] w-[40px] items-center justify-center  rounded-full border-[3px]  border-primary-blue-3 bg-neutral-white"
              onClick={onBack}
            >
              <IoChevronBack style={{ fontSize: '25px', color: '#002F76' }} />
            </button>
          )}
          <div className="absolute right-7 z-20">
            <Menu menuOptions={menuOptions} outline />
          </div>
        </div>
      </header>
      {children}
    </div>
  );
}

export default Header;
